import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_SCHOOLS: 'fetchSchools'
}

export const globalActions = getNamespacedBy('school', actionTypes)
